var _use, _symbol;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMongodb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 37 81",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 0.5,
    y: 0.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.716.218l2.135 4.01a11.98 11.98 0 0 0 1.612 2.005c1.787 1.787 3.485 3.66 5.01 5.665 3.617 4.75 6.057 9.999 7.799 15.729 1.045 3.485 1.613 7.059 1.655 10.674.175 10.807-3.53 20.086-10.999 27.798a31.74 31.74 0 0 1-3.925 3.355c-.74 0-1.09-.567-1.395-1.09-.568-.957-.915-2.05-1.09-3.137-.262-1.307-.435-2.615-.35-3.965v-.61c-.06-.155-.712-60.15-.453-60.433z",
    fill: "#599636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.716.086c-.087-.175-.175-.042-.262.042.042.875-.262 1.655-.74 2.4-.5.74-1.22 1.307-1.917 1.917C10.922 7.8 7.872 11.853 5.43 16.385 2.18 22.484.505 29.021.03 35.903c-.217 2.482.785 11.242 1.567 13.769 2.135 6.709 5.97 12.332 10.937 17.211 1.22 1.175 2.5 2.265 3.875 3.312.392 0 .435-.35.5-.61a11.96 11.96 0 0 0 .392-1.7l.875-6.535-.46-61.265z",
    fill: "#6cac48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.851 72.108c.087-1 .567-1.83 1.09-2.657-.5-.217-.915-.65-1.22-1.132-.262-.435-.48-.957-.65-1.437-.61-1.83-.74-3.75-.915-5.62v-1.132c-.217.175-.262 1.655-.262 1.875-.127 1.976-.389 3.942-.785 5.882-.13.785-.217 1.567-.7 2.265 0 .087 0 .175.042.305.785 2.31 1 4.662 1.132 7.059v.875c0 1.045-.042.825.825 1.175.35.13.74.175 1.09.435.262 0 .305-.217.305-.392l-.13-1.437v-4.01c-.042-.7.087-1.395.175-2.05z",
    fill: "#c2bfbf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodb);
export default __webpack_public_path__ + "static/media/mongodb.2f0a9a9cc9d63753a0633e61220e60b8.svg";
export { ForwardRef as ReactComponent };